import { useEffect } from 'react';
import Lenis from 'lenis';

export function useLenis() {
  useEffect(() => {
    // Lenis nur auf Desktop aktivieren - auf Touch-Geräten stört es das native Scrolling
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    if (isTouchDevice) {
      return;
    }

    const lenis = new Lenis({
      duration: 0.8, // Keep original duration
      easing: (t: number) => 1 - Math.pow(1 - t, 3), // Original cubic easing
      smooth: true,
      smoothTouch: false,
      wheelMultiplier: 1.0, // Original sensitivity
      touchMultiplier: 2, // Original touch response
      infinite: false,
      autoResize: true,
      // allowNestedScroll: Lenis erkennt scrollbare Container automatisch ueber overflow-y.
      // Wenn der Container am Rand ist und weiter in diese Richtung gescrollt wird, gibt
      // Lenis die Kontrolle zurueck und scrollt die Seite smooth weiter (Scroll-Chaining).
      allowNestedScroll: true,
    } as any);

    // Optimized RAF loop
    let rafId: number;
    function raf(time: number) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }

    rafId = requestAnimationFrame(raf);

    // Store lenis instance globally for access from other components
    (window as any).__lenis = lenis;

    // MutationObserver: Bei DOM-Änderungen (dynamischer Content) Lenis-Höhe neu berechnen
    // Nur direkte Kinder von body beobachten (nicht subtree), da tiefere Änderungen
    // selten die Scroll-Höhe beeinflussen und subtree zu häufig feuert
    let resizeTimeout: ReturnType<typeof setTimeout> | null = null;
    const observer = new MutationObserver(() => {
      if (resizeTimeout) clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        lenis.resize();
      }, 200);
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: false });

    return () => {
      cancelAnimationFrame(rafId);
      observer.disconnect();
      if (resizeTimeout) clearTimeout(resizeTimeout);
      (window as any).__lenis = null;
      lenis.destroy();
    };
  }, []);
}